import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "completa-profilo-rimandato";

export const CompletaProfilo = () => {
  const { setUser } = useAuth();
  const [miss, setMiss] = useState(null);
  const [dn, setDn] = useState("");
  const [genere, setGenere] = useState("");
  const [circ, setCirc] = useState({ numero: "", nome: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    api.get("/profile/da-completare").then((r) => (r.data.data_nascita || r.data.circolo || r.data.genere) && setMiss(r.data)).catch(() => {});
  }, []);

  const lookup = async () => {
    if (!circ.numero.trim()) return;
    try {
      const { data } = await api.get(`/circoli/${encodeURIComponent(circ.numero.trim())}`);
      setCirc({ numero: data.numero, nome: data.nome });
    } catch {
      /* not in archive */
    }
  };

  const later = () => {
    sessionStorage.setItem(KEY, "1");
    setMiss(null);
  };

  const save = async () => {
    if (miss.genere && !genere) return toast.error("Indica il genere");
    if (miss.data_nascita && !dn) return toast.error("Indica la data di nascita");
    if (miss.circolo && (!circ.numero.trim() || !circ.nome.trim())) return toast.error("Indica numero e nome del Circolo FIV");
    setSaving(true);
    try {
      const { data } = await api.put("/profile/completa", {
        data_nascita: miss.data_nascita ? dn : null,
        circolo_numero: miss.circolo ? circ.numero : null,
        circolo_nome: miss.circolo ? circ.nome : null,
        genere: miss.genere ? genere : null,
      });
      setUser(data);
      toast.success("Dati salvati");
      setMiss(null);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  if (!miss) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && later()}>
      <DialogContent data-testid="completa-profilo-dialog">
        <DialogHeader>
          <DialogTitle>Completa la tua anagrafica</DialogTitle>
          <DialogDescription>Mancano alcuni dati della tua scheda socio. Inseriscili ora.</DialogDescription>
        </DialogHeader>
        {miss.genere && (
          <div className="space-y-1">
            <Label>Genere</Label>
            <Select value={genere} onValueChange={setGenere}>
              <SelectTrigger data-testid="completa-genere-select"><SelectValue placeholder="Seleziona" /></SelectTrigger>
              <SelectContent>
                {["Uomo", "Donna", "Non indicato"].map((g) => <SelectItem key={g} value={g} data-testid={`completa-genere-option-${g.toLowerCase().replace(" ", "-")}`}>{g}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        )}
        {miss.data_nascita && (
          <div className="space-y-1">
            <Label>Data di nascita</Label>
            <Input type="date" value={dn} onChange={(e) => setDn(e.target.value)} data-testid="completa-data-nascita-input" />
          </div>
        )}
        {miss.circolo && (
          <div className="space-y-1">
            <Label>Circolo FIV di appartenenza</Label>
            <div className="grid grid-cols-[110px_1fr] gap-2">
              <Input placeholder="N. circolo" maxLength={20} value={circ.numero} onChange={(e) => setCirc({ ...circ, numero: e.target.value })} onBlur={lookup} data-testid="completa-circolo-numero-input" />
              <Input placeholder="Nome circolo" maxLength={150} value={circ.nome} onChange={(e) => setCirc({ ...circ, nome: e.target.value })} data-testid="completa-circolo-nome-input" />
            </div>
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={later} data-testid="completa-profilo-later-button">Più tardi</Button>
          <Button onClick={save} disabled={saving} data-testid="completa-profilo-save-button">{saving ? "Salvataggio..." : "Salva"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
